// Servicio global para inicializar FontAwesome
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

export function initializeFontAwesome() {
  library.add(far, fal, fab);
}
